"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreRefundStatusEnum = void 0;
/**
 * Статус возврата платежа
 */
var BillingCoreRefundStatusEnum;
(function (BillingCoreRefundStatusEnum) {
  /** Создан, ожидает исполнения */
  BillingCoreRefundStatusEnum["NEW"] = "NEW";
  /** Создан, ожидает действия или события */
  BillingCoreRefundStatusEnum["PENDING"] = "PENDING";
  /** Отменён */
  BillingCoreRefundStatusEnum["CANCEL"] = "CANCEL";
  /** Выплачено */
  BillingCoreRefundStatusEnum["PAID"] = "PAID";
  /** Невозможно выполнить возврат, ошибка */
  BillingCoreRefundStatusEnum["ERROR"] = "ERROR";
})(BillingCoreRefundStatusEnum = exports.BillingCoreRefundStatusEnum || (exports.BillingCoreRefundStatusEnum = {}));
